y<script>
  import { onMount } from 'svelte'

  import Arrow from '/Icons/Arrow';
  import Video from '/Atoms/Video'

  import { styleVars } from '/helper'
  import { lighboxSlideActive } from '/stores.js';

  export let items = [], zIndex = 0

  let scrollElem = null
  let slideWidth = 0
  let hideLeftArrow = true
  let hideRightArrow = false

  let fullscreen = true

  items = $lighboxSlideActive
  
  /*
  for (let i = 0; i<10; i++) {
    items.push(    {
      url: `https://picsum.photos/${Math.round(Math.random()*600+100)}/${Math.round(Math.random()*600+100)}`,
      text: Math.random() > 0.5 ? "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. " : "",
      credits: "Photo: Laura Fiorio, transmediale, CC BY-SA 4.0. Some rights reserved"
    })
  }
  */

  $: console.log("render", hideLeftArrow)

  const currentSlide = () => Math.round(scrollElem.scrollLeft / slideWidth)

  const numberOfSlides = () => items.length

  const scrollTo = (i, immediately=false) => {
    scrollElem.scrollTo({
      left: i * slideWidth ,
      behavior: immediately ? 'auto' : 'smooth'
    })
  }

  const next = () => {
    const i = currentSlide()
    //console.log(scrollElem.scrollLeft, slideWidth, i)
    if (i < numberOfSlides()) {
      scrollTo(i+1)
    }
  }

  const previous = () => {
    const i = currentSlide()
    //console.log(scrollElem.scrollLeft, slideWidth, i)
    if (i > 0) {
      scrollTo(i-1)
    }
  }

  const onScroll = event => {
    const scrollLeft = event.target.scrollLeft
    //console.log(scrollLeft, slideWidth * (numberOfSlides()-1))
    hideLeftArrow = scrollLeft < 1
    hideRightArrow = scrollLeft >= slideWidth * (numberOfSlides()-1)
  }

  onMount( () => {
    const index = items.findIndex( i => i.active )
    console.log("init index", index)
    if (index) scrollTo(index, true)
  })

  const onClickContainer = event => {
    //console.log(event.target.tagName)
    //if (["DIV", "FIGURE"].includes(event.target.tagName)) {
      $lighboxSlideActive = null
    //}
  }

  function handleKeydown(event) {
    if (event.code == "ArrowLeft") previous()
    if (event.code == "ArrowRight") next()
  }
  
</script>

<svelte:window on:keydown={handleKeydown}/>

<ol class:fullscreen bind:this={scrollElem} on:scroll={onScroll} on:click={onClickContainer} style={ styleVars({zIndex}) }>
  {#each items as item}
    <li>
      <figure bind:clientWidth={slideWidth}>
        {#if item.type === "image"}
          <div class="image">
            <img src={item.url} alt={item.text} />
          </div>
        {/if}
        {#if item.type === "vimeo"}
          <div class="video">
            <div class="video-inner">
              <Video vimeoUrl={item.url} />
            </div>
          </div>
        {/if}
        <figcaption>
          <p class="caption">
            {item.text}
          </p>
          <aside class="credits">
            {item.credits}
          </aside>
        </figcaption>
      </figure>
    </li>
  {/each}
</ol>

{#if !hideLeftArrow}
  <div class="controls controls-left" on:click={previous} style={ styleVars({zIndex}) }>
    <Arrow left />
  </div>
{/if}
{#if !hideRightArrow}
  <div class="controls controls-right" on:click={next} style={ styleVars({zIndex}) }>
    <Arrow right />
  </div>
{/if}

<style lang="scss">
  ol.fullscreen {
    z-index: var(--zIndex);
    position: fixed;
    left:0; top:0; right:0; bottom:0;
    background-color: $color-beige;
    scroll-snap-type: x mandatory;
    display: flex;
    overflow-x: scroll;
  }
  li {
    scroll-snap-align: center;
    scroll-snap-stop: always;
    display: inline-block;
    //background-color: rgba(255,0,0,0.5);
  }
  figure {
    width: 100vw;
    height: 100%;
    padding: 60px 90px 40px ;
    @include media-1col-only {
      padding: 60px 20px 40px;
    }
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    //background-color: rgba(0,0,255,0.5);
    @include typo-serif-caption-18;
  }
  .image {
    flex: 1;
    //background-color: rgba(234, 255, 0, 0.623);
    position: relative;
    margin-bottom: 5px;
  }
  img {
    height: auto;
    position: absolute;
    top:50%; left:50%; 
    transform: translateX(-50%) translateY(-50%);
    max-height: 100%; max-width: 100%;
    object-fit: contain;
    overflow: hidden;
    border-radius: 20px;
    @include media-small {
      border-radius: 15px;
    }
  }
  .video {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    //background-color: red;
    
    overflow: hidden;
    .video-inner {
      width: 100%;
      max-width: calc( 166vh - 90px - 90px - 10px); // TODO make it depend on figcaption height
    }
  }
  figcaption {
    text-align: center;
    .caption {
      min-height: 1em;
    }
  }

  .controls {
    z-index: var(--zIndex);
    position: fixed;
    top:0;
    bottom:0;
    width: 90px;
    //background-color: rgba(0,0,255,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    mix-blend-mode: difference;
    cursor: pointer;

    @include media-1col-only {
      display: none;
    }
  }

  .controls-right {
    right:0;
  }

  .controls-left {
    left:0;
  }

</style>